import React from 'react';
import ReactDOM from 'react-dom';
import { Game } from './Game';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';



import './index.css';

ReactDOM.render(
  <Game />,
  document.getElementById('root')
);
